"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "card-corporation-label" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardRenderItemComponent = (0, vue_1.resolveComponent)("CardRenderItemComponent");
    const _component_CardRenderSymbolComponent = (0, vue_1.resolveComponent)("CardRenderSymbolComponent");
    const _component_CardRenderEffectBoxComponent = (0, vue_1.resolveComponent)("CardRenderEffectBoxComponent");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.getClasses())
    }, [
        (0, vue_1.createElementVNode)("div", _hoisted_1, (0, vue_1.toDisplayString)(_ctx.label), 1),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.rows[0], (rowData, index) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", { key: index }, [
                (rowData && typeof rowData === 'object' && rowData.is === 'item')
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderItemComponent, {
                        key: 0,
                        item: rowData
                    }, null, 8, ["item"]))
                    : (rowData && typeof rowData === 'object' && rowData.is === 'symbol')
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderSymbolComponent, {
                            key: 1,
                            item: rowData
                        }, null, 8, ["item"]))
                        : (0, vue_1.createCommentVNode)("", true),
                (rowData && typeof rowData === 'object' && rowData.is === 'effect')
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderEffectBoxComponent, {
                        key: 2,
                        effectData: rowData
                    }, null, 8, ["effectData"]))
                    : (0, vue_1.createCommentVNode)("", true)
            ]));
        }), 128))
    ], 2));
}
